import { IBFHistoryRecordDefinition } from "@/lib/drivers/insulet/IBFHistoryLogs/HistoryRecordParser";

export type IBFTerminateBolus = {
  insulinLeft: number;
  timeLeft: number;
};

export const IBF_TERMINATE_BOLUS = {
  value: 0x2000,
  name: "IBF_TERMINATE_BOLUS",
  size: 6,
  parse: (record): IBFTerminateBolus => {
    const insulinLeft = record.nextUInt32LE() / 100.0;
    const timeLeft = record.nextUInt16LE() * 60 * 1000;
    return {
      insulinLeft,
      timeLeft,
    };
  },
} satisfies IBFHistoryRecordDefinition<IBFTerminateBolus>;
